export default "__VITE_ASSET__dyMyT1tr__"